import Cookies from 'js-cookie'
const TokenKey = 'access_token';

//httponly
Cookies.defaults={
	httponly:false
};

/*export function isTimeOut() {
	let curTime = new Date().getTime();
	if(getToken()) {
		if(getDeadline()&&curTime > getDeadline()) {
			return true;
		}else{
			return false;
		}
	}

}*/
export function setDisplayName(name){
	return sessionStorage.setItem('displayName',name);
}

export function setClaim(list){
	let jsonStr=JSON.stringify(list);
	sessionStorage.setItem('claims',jsonStr);
};

export function getClaim()
{
	try{
		let str=sessionStorage.getItem('claims')||'[]';
		return JSON.parse(str)||[];
	}catch(err){
		return [];
	}
}

export function hasClaim(claim){
	let claims=getClaim();
	// console.log('hasClaim',claims,claim);
	return claims.findIndex(t=>t==claim)>=0;
}

export function getDisplayName(){
	return sessionStorage.getItem('displayName');
}
export function setAdminName(name){
	return sessionStorage.setItem('sAdminName',name);
}

export function getAdminName(){
	return sessionStorage.getItem('sAdminName');
}
export function removeAdminName(){
	return sessionStorage.removeItem('sAdminName');
}
export function removeDisplayName(){
	return sessionStorage.removeItem('displayName');
}

export function setcurStoreId(id){
	return sessionStorage.setItem('curStoreId',id||'');
}

export function setFullName(name){
	return sessionStorage.setItem('curFullName',name);	
}

export function setPersonnelId(id){
	id=id||'';
	return sessionStorage.setItem('curPersonnelId',id);
}

export function getPersonnelId(){
	let id=sessionStorage.getItem('curPersonnelId');
	if(id){
		return +id;
	}
	return null;
}

export function getFullName(name){
	return sessionStorage.getItem('curFullName');
}

export function getcurStoreId(){
	let v=sessionStorage.getItem('curStoreId');
	if(v){
		return +v;
	}
	return null;
}

export function removecurStoreId(){
	return sessionStorage.removeItem('curStoreId');
}

export function getToken() {
	// return Cookies.get(TokenKey);
	return localStorage.getItem('TokenKey');
}

export function setToken(token) {
	// return Cookies.set(TokenKey, token);
	return localStorage.setItem('TokenKey',token);
}

export function removeToken() {
	// return Cookies.remove(TokenKey);
	return localStorage.removeItem("TokenKey");
}

/*export function getDeadline() {
	return Number(localStorage.getItem("deadline"));
}

export function setDeadline(time) {
	return localStorage.setItem("deadline", time*1000);
}*/

export function getRefreshToken() {
	return localStorage.getItem("refreshToken");
}

export function setRefreshToken(token) {
	return localStorage.setItem("refreshToken", token);
}

// export function setExpires(expires){
// 	return localStorage.setItem("expires", expires);
// }




// WEBPACK FOOTER //
// ./src/utils/auth.js